import {RouteDefinition} from "../../../routes"
import {SIPFormatEditScreen} from "./SIPFormatEditScreen"
import {SIPFormatListScreen} from "./SIPFormatListScreen"

export const SIPFormatRoutes: RouteDefinition[] = [
    {
        routerLink: "/developer/sip-format",
        component: SIPFormatListScreen
    },
    {
        routerLink: "/developer/sip-format/edit",
        component: SIPFormatEditScreen
    },
    {
        routerLink: "/developer/sip-format/edit/:id",
        component: SIPFormatEditScreen
    }
]
